import { SpreadType } from '../types';
import { supabase } from '../config/supabase';
import { getSpreadGuide } from './guideService';

interface VirtualCard {
  id: string;
  name: string;
  arcana_type: string;
  suit: string | null;
  image_url: string | null;
  meaning_summary: string | null;
  themes: string[] | null;
  shadow_themes: string[] | null;
  arcana_info: string | null;
  traditional_imagery: string | null;
  position: string;
  isReversed: boolean;
}

export async function generateVirtualSpread(spreadType: SpreadType): Promise<VirtualCard[]> {
  try {
    // Get all upright cards from the database
    const { data: cards, error } = await supabase
      .from('tarot_cards')
      .select(`
        id,
        card_name,
        arcana_type,
        suit,
        image_url,
        meaning_summary,
        themes,
        shadow_themes,
        arcana_info,
        traditional_imagery
      `)
      .eq('orientation', 'upright');

    if (error) throw error;
    if (!cards || cards.length === 0) {
      throw new Error('No cards available');
    }

    // Get the spread positions
    const spread = getSpreadGuide(spreadType);
    const positions = spread.positions;
    const numCards = positions.length;

    // Create a copy of the cards array to shuffle
    let availableCards = [...cards];
    const selectedCards: VirtualCard[] = [];

    // Generate the spread
    for (let i = 0; i < numCards; i++) {
      // Get a random card from the remaining available cards
      const randomIndex = Math.floor(Math.random() * availableCards.length);
      const card = availableCards[randomIndex];
      
      // Remove the selected card from available cards to prevent duplicates
      availableCards.splice(randomIndex, 1);

      // 50% chance of being reversed
      const isReversed = Math.random() > 0.5;

      selectedCards.push({
        id: card.id,
        name: card.card_name,
        arcana_type: card.arcana_type,
        suit: card.suit,
        image_url: card.image_url,
        meaning_summary: card.meaning_summary,
        themes: isReversed ? card.shadow_themes : card.themes,
        shadow_themes: card.shadow_themes,
        arcana_info: card.arcana_info,
        traditional_imagery: card.traditional_imagery,
        position: positions[i].name,
        isReversed
      });
    }

    return selectedCards;
  } catch (error) {
    console.error('Error generating virtual spread:', error);
    throw error;
  }
}